var _defs, _style, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217 237",
    width: 217,
    height: 237,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-10 129v-144h237.6v144h-10.8c0 59.65-48.35 108-108 108-59.65 0-108-48.35-108-108z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.8 17.4c27.84 0 50.4 22.56 50.4 50.4v5.55c5.11 0.86 9 5.3 9 10.65v12.6c0 5.45-4.03 9.95-9.28 10.69-1.86 17.83-13.01 32.89-28.52 40.26v16.55h3.6c35.79 0 64.8 29.01 64.8 64.8v8.1h-180v-8.1c0-35.79 29.01-64.8 64.8-64.8h3.6v-16.55c-15.51-7.37-26.66-22.43-28.53-40.26-5.24-0.74-9.27-5.24-9.27-10.69v-12.6c0-5.35 3.89-9.79 9-10.65v-5.55c0-27.84 22.56-50.4 50.4-50.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.8 17.4c27.84 0 50.4 22.56 50.4 50.4v5.55c5.11 0.86 9 5.3 9 10.65v12.6c0 5.45-4.03 9.95-9.28 10.69-1.86 17.83-13.01 32.89-28.52 40.26v16.55h3.6c35.79 0 64.8 29.01 64.8 64.8v8.1h-180v-8.1c0-35.79 29.01-64.8 64.8-64.8h3.6v-16.55c-15.51-7.37-26.66-22.43-28.53-40.26-5.24-0.74-9.27-5.24-9.27-10.69v-12.6c0-5.35 3.89-9.79 9-10.65v-5.55c0-27.84 22.56-50.4 50.4-50.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.4 149.76c16.29 1.83 28.8 6.84 28.8 19.81l-0.01-0.39c23.28 9.83 39.61 32.87 39.61 59.72v8.1h-180v-8.1c0-26.85 16.33-49.89 39.61-59.72 0.24-12.68 12.66-17.61 28.79-19.42v17.04c0 11.93 9.67 21.6 21.6 21.6 11.93 0 21.6-9.67 21.6-21.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.4 149.76c16.29 1.83 28.8 6.84 28.8 19.81l-0.01-0.39c23.28 9.83 39.61 32.87 39.61 59.72v8.1h-180v-8.1c0-26.85 16.33-49.89 39.61-59.72 0.24-12.68 12.66-17.61 28.79-19.42v17.04c0 11.93 9.67 21.6 21.6 21.6 11.93 0 21.6-9.67 21.6-21.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.4 149.76c16.29 1.83 28.8 6.84 28.8 19.81l-0.01-0.39c23.28 9.83 39.61 32.87 39.61 59.72v8.1h-180v-8.1c0-26.85 16.33-49.89 39.61-59.72 0.24-12.68 12.66-17.61 28.79-19.42v17.04c0 11.93 9.67 21.6 21.6 21.6 11.93 0 21.6-9.67 21.6-21.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.81 119.22c0.95 8.54 8.19 15.18 16.99 15.18 8.82 0 16.09-6.68 17-15.26 0.08-0.69-0.69-1.84-1.66-1.84-13.41 0-23.68 0-30.56 0-0.97 0-1.87 1.06-1.77 1.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.81 119.22c0.95 8.54 8.19 15.18 16.99 15.18 8.82 0 16.09-6.68 17-15.26 0.08-0.69-0.69-1.84-1.66-1.84-13.41 0-23.68 0-30.56 0-0.97 0-1.87 1.06-1.77 1.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-10-15h237.6v252h-237.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.13 20.93c-2.48-2.54-5.36-4.69-8.17-6.85q-0.93-0.71-1.85-1.44c-0.14-0.11-1.55-1.12-1.72-1.49-0.4-0.9-0.17-0.2-0.11-1.27 0.07-1.34 2.82-5.15 0.77-6.03-0.9-0.38-2.51 0.64-3.38 0.98q-2.54 0.99-5.16 1.71c0.84-1.67 2.44-5.02-0.57-4.12-2.34 0.7-4.52 2.49-6.87 3.33 0.78-1.27 3.89-5.23 1.08-5.45-0.88-0.07-3.43 1.58-4.37 1.93-2.82 1.04-5.71 1.72-8.67 2.26-10.08 1.81-21.86 1.3-31.19 5.88-7.19 3.54-14.28 9.03-18.44 16.02-4 6.74-5.5 14.11-6.33 21.83-0.62 5.66-0.67 11.52-0.38 17.2 0.09 1.87 0.3 10.45 3.01 7.85 1.35-1.29 1.34-6.52 1.68-8.3 0.67-3.52 1.32-7.06 2.45-10.47 1.99-6.01 4.33-8.81 9.27-12.95 3.18-2.66 5.41-6.25 8.45-8.93 1.36-1.2 0.32-1.08 2.51-0.92 1.48 0.11 2.96 0.15 4.43 0.18 3.42 0.09 6.84 0.07 10.26 0.08 6.88 0.03 13.73 0.13 20.61-0.24 3.05-0.16 6.12-0.24 9.16-0.52 1.71-0.16 4.73-1.25 6.13-0.42 1.28 0.76 2.61 3.25 3.53 4.27 2.18 2.41 4.77 4.26 7.32 6.23 5.3 4.12 7.98 5.7 9.59 12.14 1.61 6.42 1.16 12.37 3.14 18.69 0.35 1.11 1.28 3.02 2.42 1.31 0.21-0.32 0.15-2.07 0.15-3.08 0-4.07 1.03-7.12 1.02-11.22-0.05-12.45-0.45-28.68-9.77-38.19z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #492dc2 } \n\t\t.s1 { fill: #d0c6ac } \n\t\t.s2 { fill: #ffdbb4 } \n\t\t.s3 { opacity: .1;fill: #000000 } \n\t\t.s4 { fill: #b7c1db } \n\t\t.s5 { fill: #293347 } \n\t\t.s6 { fill: #f4f4f4 } \n\t\t.s7 { opacity: .2;fill: #000000 } \n\t\t.s8 { fill: #000000 } \n\t\t.s9 { fill: #ffffff } \n\t\t.s10 { fill: #ff4f6d } \n\t\t.s11 { fill: #1f3140 } \n\t\t.s12 { fill: #4a312c } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Website"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mf-avatar"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m108.8 237c-59.7 0-108-48.3-108-108 0-59.7 48.3-108 108-108 59.7 0 108 48.3 108 108 0 59.7-48.3 108-108 108z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Avataaar",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avataaar"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.8 17.4c27.8 0 50.4 22.6 50.4 50.4v5.5c5.1 0.9 9 5.3 9 10.7v12.6c0 5.4-4 10-9.3 10.7-1.8 17.8-13 32.9-28.5 40.2v16.6h3.6c35.8 0 64.8 29 64.8 64.8v8.1h-180v-8.1c0-35.8 29-64.8 64.8-64.8h3.6v-16.6c-15.5-7.3-26.7-22.4-28.5-40.2-5.3-0.7-9.3-5.3-9.3-10.7v-12.6c0-5.4 3.9-9.8 9-10.7v-5.5c0-27.8 22.6-50.4 50.4-50.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Skin/\\uD83D\\uDC76\\uD83C\\uDFFB-05-Pale",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFB-05-Pale"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m-10 17.4h238.4v220.4h-238.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Neck-Shadow",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    fillRule: "evenodd",
    className: "s3",
    d: "m58.4 102c0 27.8 22.6 50.4 50.4 50.4 27.8 0 50.4-22.6 50.4-50.4v7.2c0 27.8-22.6 50.4-50.4 50.4-27.8 0-50.4-22.6-50.4-50.4z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Clothing/Hoodie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    fillRule: "evenodd",
    className: "s4",
    d: "m130.4 149.8c16.3 1.8 28.8 6.8 28.8 19.8v-0.4c23.3 9.8 39.6 32.8 39.6 59.7v8.1h-180v-8.1c0-26.9 16.3-49.9 39.6-59.7 0.3-12.7 12.7-17.6 28.8-19.4v17c0 11.9 9.7 21.6 21.6 21.6 11.9 0 21.6-9.7 21.6-21.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Color/Palette/Slate",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Slate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD83D\\uDD8DColor",
    className: "s5",
    d: "m-10 138h238.5v99h-238.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Straps",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Straps",
    fillRule: "evenodd",
    className: "s6",
    d: "m81.8 193.6v43.4h-6.3v-46.7q3 1.8 6.3 3.3zm60.3-3.3v36.4c0 1.7-1.4 3.1-3.2 3.1-1.7 0-3.1-1.4-3.1-3.1v-33.1q3.3-1.5 6.3-3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Shadow",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    fillRule: "evenodd",
    className: "s7",
    d: "m145.7 149.5c13.6 2.5 23 7.6 23 17.6 0 17.7-29.8 32.1-59.9 32.1-30.1 0-59.8-14.4-59.8-32.1 0-10 9.3-15.1 22.9-17.6-8.2 3-13.5 8-13.5 16.5 0 18.3 25 33.2 50.4 33.2 25.4 0 50.4-14.9 50.4-33.2 0-8.3-5.1-13.3-13-16.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Mouth/Smile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    fillRule: "evenodd",
    className: "s8",
    d: "m91.8 119.2c1 8.6 8.2 15.2 17 15.2 8.8 0 16.1-6.7 17-15.3 0.1-0.7-0.7-1.8-1.7-1.8-13.4 0-23.6 0-30.5 0-1 0-1.9 1.1-1.8 1.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Teeth",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Teeth",
    fillRule: "evenodd",
    className: "s9",
    d: "m99.8 107.4h18.9c2.5 0 4.5 2 4.5 4.5v5.4c0 2.5-2 4.5-4.5 4.5h-18.9c-2.5 0-4.5-2-4.5-4.5v-5.4c0-2.5 2-4.5 4.5-4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Tongue",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tongue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m104.3 147c-5.5 0-9.9-4.4-9.9-9.9 0-5.5 4.4-9.9 9.9-9.9 5.5 0 9.9 4.4 9.9 9.9 0 5.5-4.4 9.9-9.9 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m113.3 147c-5.5 0-9.9-4.4-9.9-9.9 0-5.5 4.4-9.9 9.9-9.9 5.5 0 9.9 4.4 9.9 9.9 0 5.5-4.4 9.9-9.9 9.9z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Nose/Default",
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    fillRule: "evenodd",
    className: "s8",
    d: "m98 102c0 4 4.8 7.2 10.8 7.2 6 0 10.8-3.2 10.8-7.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Eyes/Happy-\\uD83D\\uDE01",
    style: {
      opacity: 0.6
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Squint",
    fillRule: "evenodd",
    className: "s8",
    d: "m72.9 86.2c1.7-3.4 5.4-5.8 9.8-5.8 4.3 0 8.1 2.4 9.7 5.8 0.5 1-0.2 1.8-0.9 1.2-2.2-1.9-5.3-3.1-8.8-3.1-3.4 0-6.4 1.1-8.6 2.9-0.8 0.7-1.6 0-1.2-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Squint",
    fillRule: "evenodd",
    className: "s8",
    d: "m125.1 86.2c1.7-3.4 5.4-5.8 9.8-5.8 4.3 0 8.1 2.4 9.7 5.8 0.5 1-0.2 1.8-0.9 1.2-2.2-1.9-5.3-3.1-8.8-3.1-3.4 0-6.4 1.1-8.6 2.9-0.8 0.7-1.6 0-1.2-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow/Natural/Default-Natural",
    style: {
      opacity: 0.6
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    fillRule: "evenodd",
    className: "s8",
    d: "m82.3 64.3c-5.2 0.3-13.7 4.1-13.5 9.3 0 0.2 0.3 0.3 0.4 0.2 2.5-2.7 20.1-5.4 26.3-4 0.6 0.2 1-0.4 0.6-0.8-3-3.5-9.1-4.9-13.8-4.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    fillRule: "evenodd",
    className: "s8",
    d: "m136.2 64.3c5.2 0.3 13.7 4.1 13.5 9.3 0 0.2-0.3 0.3-0.4 0.2-2.5-2.7-20.1-5.4-26.3-4-0.6 0.2-1-0.4-0.6-0.8 3-3.5 9.1-4.9 13.8-4.7z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-13",
    fillRule: "evenodd",
    className: "s11",
    d: "m151.1 20.9c-2.4-2.5-5.3-4.7-8.1-6.8q-1-0.7-1.9-1.5c-0.1-0.1-1.5-1.1-1.7-1.5-0.4-0.8-0.2-0.2-0.1-1.2 0.1-1.4 2.8-5.2 0.7-6-0.9-0.4-2.5 0.6-3.3 0.9q-2.6 1-5.2 1.7c0.9-1.6 2.4-5-0.6-4.1-2.3 0.7-4.5 2.5-6.8 3.4 0.7-1.3 3.9-5.3 1-5.5-0.8-0.1-3.4 1.6-4.3 1.9-2.8 1.1-5.7 1.8-8.7 2.3-10.1 1.8-21.9 1.3-31.2 5.9-7.2 3.5-14.3 9-18.4 16-4 6.7-5.5 14.1-6.4 21.8-0.6 5.7-0.6 11.5-0.3 17.2 0.1 1.9 0.3 10.5 3 7.9 1.3-1.3 1.3-6.6 1.7-8.3 0.6-3.5 1.3-7.1 2.4-10.5 2-6 4.3-8.8 9.3-13 3.2-2.6 5.4-6.2 8.4-8.9 1.4-1.2 0.3-1.1 2.5-0.9 1.5 0.1 3 0.1 4.5 0.2 3.4 0.1 6.8 0.1 10.2 0.1 6.9 0 13.8 0.1 20.6-0.3 3.1-0.1 6.2-0.2 9.2-0.5 1.7-0.2 4.7-1.3 6.1-0.4 1.3 0.7 2.6 3.2 3.6 4.3 2.1 2.4 4.7 4.2 7.3 6.2 5.3 4.1 8 5.7 9.6 12.1 1.6 6.4 1.1 12.4 3.1 18.7 0.4 1.1 1.3 3 2.4 1.3 0.2-0.3 0.2-2.1 0.2-3.1 0-4 1-7.1 1-11.2-0.1-12.4-0.5-28.7-9.8-38.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Color/Hair/Brown-Dark",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/Hair/Brown-Dark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m-10.1-15h239.1v252.4h-239.1z"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.61b91e95354050ba5569b4e928ce02ee.svg";
export { ForwardRef as ReactComponent };